// extracted by mini-css-extract-plugin
export default {"form":"MenuItemForm_form__qqmEb"};